import { registerQuery } from 'data-fetching-client';
import { fetchUsersForInbox } from '../api/users.api';
import { fetchRoutingUsersRpc } from '../api/users.rpc';
import { convertRpcUsersToInboxUsers } from '../utils/rpc-users';
const checkIsRpcProps = props => !!props.objectTypeId && typeof props.objectTypeId === 'string';
const checkIsRestProps = props => !!props.workspaceId && typeof props.workspaceId === 'number';
export const fetchRoutingUsersQuery = registerQuery({
  args: ['includeBots', 'objectTypeId', 'routingSource', 'specificUsers', 'workspaceId'],
  fieldName: 'routingUsers',
  fetcher: async props => {
    if (checkIsRpcProps(props)) {
      const rpcResponse = await fetchRoutingUsersRpc(props);
      return convertRpcUsersToInboxUsers(rpcResponse.routableUsers);
    }
    if (checkIsRestProps(props)) {
      return fetchUsersForInbox({
        agentIds: props.specificUsers,
        inboxId: props.workspaceId
      });
    }
    throw new Error('Cannot fetch users without a workspaceId or objectTypeId');
  }
});